import React from "react";
import { chakra } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import CapsuleGallery from "@/components/Triggers/CapsuleGallery";
import { allSDSamplers, SDSampler } from "@/modules/editor/constant";
import { useTranslate } from "@/utils/lang";
import { AI_Params_Words } from "@/utils/lang/aiParams";
import { WithClassName } from "@/types/base";

const Samplers: React.FC<
  WithClassName<{
    value: SDSampler;
    onChange: (value: SDSampler) => void;
  }>
> = ({ value, onChange, className }) => {
  const { translate } = useTranslate();
  return (
    <CapsuleGallery
      className={className}
      words={allSDSamplers as unknown as string[]}
      panelTitle={translate(AI_Params_Words["sampler-title"])}
      storeValue={value}
      setStoreValue={(sampler) => {
        onChange(sampler);
      }}
    />
  );
};

export const SamplerSelector = chakra(observer(Samplers));
